import { IOfferState, ICoordinates } from '../../redux/reducers';

export const getCoordinates = (offer: IOfferState) => {
  return offer && offer.geo && offer.geo.coordinates || {} as ICoordinates;
};
